/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddTeamDto } from '../models/AddTeamDto';
import type { PageTeamSearchResultDto } from '../models/PageTeamSearchResultDto';
import type { TeamDetailsDto } from '../models/TeamDetailsDto';
import type { TeamDto } from '../models/TeamDto';
import type { TeamSearchCriteriaDto } from '../models/TeamSearchCriteriaDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamControllerService {
    /**
     * @param requestBody
     * @returns TeamDetailsDto Created
     * @throws ApiError
     */
    public static createTeam(
        requestBody: AddTeamDto,
    ): CancelablePromise<TeamDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/teams',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param scheduleId
     * @param requestBody
     * @param page
     * @param size
     * @returns PageTeamSearchResultDto OK
     * @throws ApiError
     */
    public static searchTeams(
        requestBody: TeamSearchCriteriaDto,
        scheduleId?: number,
        page?: number,
        size: number = 10,
    ): CancelablePromise<PageTeamSearchResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/teams/search',
            query: {
                'scheduleId': scheduleId,
                'page': page,
                'size': size,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param teamId
     * @param tier
     * @returns void
     * @throws ApiError
     */
    public static updateTier(
        teamId: number,
        tier: 'EKSTRAKLASA' | 'FIRST_LEAGUE' | 'SECOND_LEAGUE' | 'THIRD_LEAGUE' | 'FOURTH_LEAGUE' | 'FIFTH_LEAGUE' | 'REGIONAL_CLASS' | 'CLASS_A' | 'CLASS_B' | 'CLASS_C' | 'CLJ' | 'VOIVODESHIP_I' | 'VOIVODESHIP_2' | 'VOIVODESHIP_3' | 'REGIONAL',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/teams/{teamId}/tier',
            path: {
                'teamId': teamId,
            },
            query: {
                'tier': tier,
            },
        });
    }
    /**
     * @param id
     * @returns TeamDetailsDto OK
     * @throws ApiError
     */
    public static getTeamDetails(
        id: number,
    ): CancelablePromise<TeamDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/teams/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteTeam(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/teams/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @returns TeamDetailsDto OK
     * @throws ApiError
     */
    public static getTeamsByUserId(
        userId: number,
    ): CancelablePromise<Array<TeamDetailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/teams/user/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param sportsClubId
     * @returns TeamDto OK
     * @throws ApiError
     */
    public static getTeamsBySportsClubId(
        sportsClubId: number,
    ): CancelablePromise<Array<TeamDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/teams/sports-club/{sportsClubId}',
            path: {
                'sportsClubId': sportsClubId,
            },
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getTotalTeamCount(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/teams/count',
        });
    }
}
